import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Mission from './components/Mission';
import Story from './components/Story';
import Values from './components/Values';
import Team from './components/Team';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  useEffect(() => {
    // Update meta tags for About page
    document.title = 'About Us - EasyMarketPro AI Customer Support Solutions';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn about EasyMarketPro\'s mission to revolutionize customer support with AI agents. Discover our story, values, and team dedicated to reducing ticket volume and support costs for businesses worldwide.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'about EasyMarketPro, AI customer support company, customer support automation team, AI agents mission, support technology innovation');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://easymarketpro.tech/about');
    }
    
    // Add structured data for About page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About EasyMarketPro",
      "description": "Learn about EasyMarketPro's mission to revolutionize customer support with AI agents",
      "url": "https://easymarketpro.tech/about",
      "mainEntity": {
        "@type": "Organization",
        "name": "EasyMarketPro",
        "description": "AI customer support agents that reduce ticket volume and support costs"
      }
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      
      <div
        className="relative h-[400px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Modern%20professional%20abstract%20background%20with%20warm%20beige%20cream%20and%20gold%20gradient%20tones%20featuring%20elegant%20geometric%20patterns%20and%20soft%20flowing%20lines%20creating%20a%20sophisticated%20corporate%20atmosphere%20perfect%20for%20about%20us%20pages%20with%20clean%20minimalist%20design%20and%20subtle%20lighting%20effects&width=1920&height=800&seq=about-hero-bg-001&orientation=landscape)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="relative z-10 text-center px-5">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-sm mb-5">
            <div className="w-2 h-2 rounded-full bg-[#B8985F] animate-pulse"></div>
            <span className="text-[12px] tracking-[1.5px] uppercase text-white font-semibold">
              Our Story
            </span>
          </div>
          <h2 className="text-[36px] md:text-[48px] font-bold text-white mb-4">
            About EasyMarketPro
          </h2>
          <p className="text-[16px] md:text-[18px] text-white/90 max-w-[600px] mx-auto leading-[1.7]">
            Empowering support teams with <strong>AI customer support agents</strong> that reduce ticket volume and transform customer experiences
          </p>
        </div>
      </div>

      <Mission />
      <Story />
      <Values />
      <Team />

      <div className="bg-black py-16 md:py-20">
        <div className="max-w-[900px] mx-auto px-5 md:px-8 text-center">
          <h4 className="text-[28px] md:text-[36px] font-bold text-white mb-5">
            <a href="/book-a-call" className="hover:text-[#B8985F] transition-colors">
              Ready to Transform Your Support?
            </a>
          </h4>
          <p className="text-[15px] md:text-[17px] text-[#CCC] mb-8 leading-[1.7]">
            Join forward-thinking companies using <strong>AI agents to reduce ticket volume</strong> and support costs
          </p>
          <a
            href="/book-a-call"
            className="inline-block px-8 py-4 bg-[#B8985F] hover:bg-[#A68850] text-white text-[15px] font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap"
          >
            Book a Strategy Call
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
